import { ExportIcon } from './ExportIcon';

/**
 * author: Austin Andrews
 * id 670C2CEA-D9B1-4126-89F4-C881D032F3AD
 * name export
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/export.svg
 * tags
 */
export const OutputIcon = ExportIcon;
export default OutputIcon